import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('assetToggle');

    return {
        BATTERY: ({ count }: { count: number }) => t('battery', { count }),
        DRONE: ({ count }: { count: number }) => t('drone', { count })
    };
};

export default useTranslation;
